import React from 'react';
import { Box, InputBase, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const CustomGlobalFilter = ({ value, onChange, placeholder = 'Search...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: {xs:'100%',sm:'300px'},
        height: '40px',
        border: '1px solid #E5E7EB',
        borderRadius: '6px',
        px: 1.5,
        '&:hover': {
          borderColor: '#B0B9C4',
        },
        '&:focus-within': {
          borderColor: '#2563EB',
          boxShadow: '0 0 0 1px #2563EB',
        },
      }}
    >
      <SearchIcon sx={{ color: '#6B7280', fontSize: 20 }} />
      <InputBase
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        sx={{
          ml: 1,
          flex: 1,
          fontSize: '0.875rem',
          '& .MuiInputBase-input': {
            '&::placeholder': {
              color: '#9CA3AF',
              opacity: 1,
            },
          },
        }}
      />
      {value && (
        <IconButton
          size="small"
          onClick={() => onChange({ target: { value: '' } })}
          sx={{ p: 0.5 }}
        >
          <CloseIcon sx={{ color: '#6B7280', fontSize: 18 }} />
        </IconButton>
      )}
    </Box>
  );
};

export default CustomGlobalFilter;